import asciiWords from "./component-library352.mjs";
import hasUnicodeWord from "./component-library353.mjs";
import toString from "./component-library279.mjs";
import unicodeWords from "./component-library354.mjs";
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? void 0 : pattern;
  if (pattern === void 0) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}
export {
  words as default
};
